"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestOpenHashSubmitter__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_addressRequestHashStorage",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_addressBurner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "burnerAddress",
                type: "address",
            },
        ],
        name: "UpdatedBurnerContract",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "minimumFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rateFeesNumerator",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "rateFeesDenominator",
                type: "uint256",
            },
        ],
        name: "UpdatedFeeParameters",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "threshold",
                type: "uint256",
            },
        ],
        name: "UpdatedMinimumFeeThreshold",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "WhitelistAdminAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "WhitelistAdminRemoved",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "addWhitelistAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_contentSize",
                type: "uint256",
            },
        ],
        name: "getFeesAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "isWhitelistAdmin",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rateFeesDenominator",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rateFeesNumerator",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceWhitelistAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "requestBurnerContract",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "requestHashStorage",
        outputs: [
            {
                internalType: "contract RequestHashStorage",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_minimumFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_rateFeesNumerator",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_rateFeesDenominator",
                type: "uint256",
            },
        ],
        name: "setFeeParameters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "_requestBurnerContract",
                type: "address",
            },
        ],
        name: "setRequestBurnerContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_hash",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "_feesParameters",
                type: "bytes",
            },
        ],
        name: "submitHash",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class RequestOpenHashSubmitter__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_addressRequestHashStorage, _addressBurner, overrides) {
        return super.deploy(_addressRequestHashStorage, _addressBurner, overrides || {});
    }
    getDeployTransaction(_addressRequestHashStorage, _addressBurner, overrides) {
        return super.getDeployTransaction(_addressRequestHashStorage, _addressBurner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.RequestOpenHashSubmitter__factory = RequestOpenHashSubmitter__factory;
RequestOpenHashSubmitter__factory.bytecode = _bytecode;
RequestOpenHashSubmitter__factory.abi = _abi;
